import { Button } from "@/components/Button"
import { FormCountrySelect } from "@/components/Form/CoutrySelect"
import { Input } from "@/components/Form/Input"
import { useRainCorporateFormContext } from "@usher/pe-client-front-end-lib"
import { useHistory } from "react-router"

const CompanyAddress = () => {
  const history = useHistory()
  const { formMethods } = useRainCorporateFormContext()
  const { control, handleSubmit } = formMethods
  return (
    <div className="">
      <h1 className="text-2xl text-black mb-4">Add Company Address</h1>

      <form noValidate autoComplete="off" onSubmit={handleSubmit(() => history.push("company-contact-details"))}>
        <label className="mb-1">Country</label>
        <FormCountrySelect disabled name="company_info.corp_country_code" control={control} required />

        <label className="mt-2.5 mb-1">Address Line 1</label>
        <Input.Form disabled name="company_info.corp_address" control={control} required />

        {/*<label className="mt-2.5 mb-1">Address Line 2</label>
        <Input.Form name="addres" required control={control} />*/}

        <label className="mt-2.5 mb-1">State</label>
        <Input.Form disabled name="company_info.corp_state" control={control} required />

        <div className="grid grid-cols-2 gap-2.5 mt-2.5">
          <div className="col-span-1">
            <label className="mb-1">City</label>
            <Input.Form disabled name="company_info.corp_city" required control={control} />
          </div>
          <div className="col-span-1">
            <label className="mb-1">Zip</label>
            <Input.Form disabled name="company_info.corp_zip" required control={control} />
          </div>
        </div>

        <div className="flex justify-end mt-4">
          <Button className="w-full">Continue</Button>
        </div>
      </form>
    </div>
  )
}

export default CompanyAddress
